import React, { useEffect, useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Modal } from "react-bootstrap";
import bannerImage from "../../Images/International/prospective-international-students-banner.webp";
import { Link } from "react-router-dom";
import Arrival from "../../Images/International/arrival.webp";
import Currency from "../../Images/International/currency.webp";
import Climate from "../../Images/International/earth.webp";
import Device from "../../Images/International/Devices.webp";
import Admission from "../../Images/International/admission.webp";
import Register from "../../Images/International/Register.webp";
import Student from "../../Images/International/students.webp";
import opportunity from "../../Images/International/opportunity.webp";
import success from "../../Images/International/success-path.webp";
import EnquiryNow from "../common/EnquiryNow";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  if (text.length > 100) {
    return (
      <p className="card-text">
        {isReadMore ? text.slice(0, 100) : text}
        <br />
        <button
          style={{ float: "right" }}
          onClick={toggleReadMore}
          className="bg-white border-0 fs-6 text-secondary"
        >
          {isReadMore ? "...Read More" : "Show Less"}
        </button>
      </p>
    );
  } else {
    return <p className="card-text">{text}</p>;
  }
};

const InternationalStudents = () => {
  const [modalShow2, setModalShow2] = useState(false);

  return (
    <React.Fragment>
      <title>Study at ISBM University – For International Students</title>
      <meta
        name="description"
        content="ISBM University provides international students with academic guidance, accommodation, visa help, and a welcoming campus environment."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>International Students</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  International Students
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="section-intro text-center mb-5">
                <h2 className="text-blue modern-title section-title">
                  Welcome to ISBM University
                </h2>
                <p className="lead">
                  Essential information for our international student community
                </p>
              </div>

              <div className="international-guide">
                <Row className="row-cols-1 row-cols-lg-4 row-cols-md-2 g-4">
                  {/* Pre-Arrival Preparation */}
                  <Col className="mb-4">
                    <div className="guide-card h-100 border-0 shadow rounded-3 overflow-hidden">
                      <div className="guide-image-container">
                        <img
                          src={Arrival}
                          className="guide-image h-100 w-100"
                          alt="Pre-Arrival Preparation"
                        />
                      </div>
                      <div className="card-body p-4">
                        <h3 className="h4 mb-3 text-blue">
                          <b>Pre-Arrival Preparation</b>
                        </h3>
                        <ReadMore>
                          Update the University on Visa Status upon Admission
                          confirmation. Bring a Medical Certificate from an
                          authorized doctor, stating fitness. Ensure
                          vaccinations for Yellow Fever, Typhoid, Hepatitis, and
                          Covid. Notify ISBM University two weeks before arrival
                          for Airport pickup, providing flight details. Carry
                          University Admission letter, original
                          Certificates/Degrees, Transcripts, and 15 passport
                          size photographs.
                        </ReadMore>
                      </div>
                    </div>
                  </Col>

                  {/* Financial Preparations */}
                  <Col className="mb-4">
                    <div className="guide-card h-100 border-0 shadow rounded-3 overflow-hidden">
                      <div className="guide-image-container">
                        <img
                          src={Currency}
                          className="guide-image h-100 w-100"
                          alt="Financial Preparations"
                        />
                      </div>
                      <div className="card-body p-4">
                        <h3 className="h4 mb-3 text-blue">
                          <b>Financial Preparations</b>
                        </h3>
                        <ReadMore>
                          Consult Indian Embassy for currency limits; consider
                          Travelers Cheques or international Debit/Credit Cards.
                          Confirm FRRO/FRO process with the Indian Embassy.
                        </ReadMore>
                      </div>
                    </div>
                  </Col>

                  {/* Climate and Essentials */}
                  <Col className="mb-4">
                    <div className="guide-card h-100 border-0 shadow rounded-3 overflow-hidden">
                      <div className="guide-image-container">
                        <img
                          src={Climate}
                          className="guide-image h-100 w-100"
                          alt="Climate and Essentials"
                        />
                      </div>
                      <div className="card-body p-4">
                        <h3 className="h4 mb-3 text-blue">
                          <b>Climate and Essentials</b>
                        </h3>
                        <ReadMore>
                          Prepare for temperatures between 30 to 45 degrees
                          Celsius in summer and 20 to 25 degrees Celsius in
                          winter (starting from November). Bring warm materials
                          like blankets, quilts, and woolens. Get essential
                          items from markets near the university campus.
                        </ReadMore>
                      </div>
                    </div>
                  </Col>

                  {/* Electrical Considerations */}
                  <Col className="mb-4">
                    <div className="guide-card h-100 border-0 shadow rounded-3 overflow-hidden">
                      <div className="guide-image-container">
                        <img
                          src={Device}
                          className="guide-image h-100 w-100"
                          alt="Electrical Considerations"
                        />
                      </div>
                      <div className="card-body p-4">
                        <h3 className="h4 mb-3 text-blue">
                          <b>Electrical Considerations</b>
                        </h3>
                        <ReadMore>
                          Devices should operate on 240 V AC; carry adapters for
                          mobiles or laptops. Electrical sockets are 2 or 3 pin
                          (round holes); bring a converter/adapter.
                        </ReadMore>
                      </div>
                    </div>
                  </Col>

                  {/* Admission Formalities */}
                  <Col className="mb-4">
                    <div className="guide-card h-100 border-0 shadow rounded-3 overflow-hidden">
                      <div className="guide-image-container">
                        <img
                          src={Admission}
                          className="guide-image h-100 w-100"
                          alt="Admission Formalities"
                        />
                      </div>
                      <div className="card-body p-4">
                        <h3 className="h4 mb-3 text-blue">
                          <b>Admission Formalities</b>
                        </h3>
                        <ReadMore>
                          Present all necessary documents at the Office of
                          International Relations (OIR). Communicate with the
                          reporting officer to complete admission formalities.
                        </ReadMore>
                      </div>
                    </div>
                  </Col>

                  {/* Post-Arrival Obligations */}
                  <Col className="mb-4">
                    <div className="guide-card h-100 border-0 shadow rounded-3 overflow-hidden">
                      <div className="guide-image-container">
                        <img
                          src={Register}
                          className="guide-image h-100 w-100"
                          alt="Post-Arrival Obligations"
                        />
                      </div>
                      <div className="card-body p-4">
                        <h3 className="h4 mb-3 text-blue">
                          <b>Post-Arrival Obligations</b>
                        </h3>
                        <ReadMore>
                          Register student visa in FRRO/FRO/Chhattisgarh within
                          14 days. University provides support for this process
                          (refer to FRRO.pdf). Report for a medical checkup at
                          the Office of International Relations (OIR); receive
                          advice on the medical insurance process.
                        </ReadMore>
                      </div>
                    </div>
                  </Col>

                  {/* Airport Arrival and Immigration */}
                  <Col className="mb-4">
                    <div className="guide-card h-100  border-0 shadow rounded-3 overflow-hidden">
                      <div className="guide-image-container">
                        <img
                          src={Student}
                          className="guide-image h-100 w-100"
                          alt="Airport Arrival and Immigration"
                        />
                      </div>
                      <div className="card-body p-4">
                        <h3 className="h4 mb-3 text-blue">
                          <b>Airport Arrival and Immigration</b>
                        </h3>
                        <ReadMore>
                          University arranges airport pickup for students
                          sharing flight details. Submit documents at
                          Immigration Counter; ensure passport is stamped.
                        </ReadMore>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          {/* Unparalleled Opportunities */}
          <Row className="align-items-center mb-5">
            <Col lg={6} className="order-lg-1 order-2">
              <div className="content-block pe-lg-4">
                <h2 className="section-title-start modern-title text-blue">
                  Unparalleled Opportunities Awaits You!
                </h2>
                <p>
                  Discover a world of opportunities at ISBM University with over
                  100 undergraduate, postgraduate, and doctoral degree programs.
                  Our esteemed faculty members, known for their excellence in
                  teaching and research, will guide you through your academic
                  journey, ensuring you receive a top-tier education that
                  prepares you for success.
                </p>
              </div>
            </Col>
            <Col lg={6} className="order-lg-2 order-1 mb-4 mb-lg-0">
              <div className="image-block rounded-3 overflow-hidden shadow-lg">
                <img
                  src={opportunity}
                  alt="Global Classroom"
                  className="img-fluid"
                />
              </div>
            </Col>
          </Row>

          {/* Global Vision */}
          <Row className="align-items-center mb-5 bg-light-blue p-4 p-lg-5 rounded-3">
            <Col lg={12} className="text-center">
              <h2 className="text-blue modern-title section-title">
                Our Global Vision
              </h2>
              <p className="lead mb-0">
                At ISBM University, our vision extends beyond borders. Through
                our globally-focused research initiatives and international
                partnerships, we aim to address global challenges and empower
                students to become effective global citizens. Step into a world
                of possibilities and embark on a transformative educational
                experience that transcends cultural boundaries.
              </p>
            </Col>
          </Row>

          {/* Path to Success */}
          <Row className="align-items-center mb-5">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="image-block rounded-3 overflow-hidden shadow-lg">
                <img src={success} alt="Campus Life" className="img-fluid" />
              </div>
            </Col>
            <Col lg={6}>
              <div className="content-block ps-lg-4">
                <h2 className="text-blue section-title-start modern-title">
                  Your Path to Success Starts Here
                </h2>
                <p>
                  With our International Partner University Program, we make it
                  seamless for you to expand your academic horizons and gain
                  invaluable international experience. Our aim is to equip you
                  with the skills and knowledge needed to thrive in an
                  interconnected world, preparing you to make a meaningful
                  impact on a global scale.
                </p>
              </div>
            </Col>
          </Row>

          {/* Embrace Diversity */}
          <Row className="mb-5">
            <Col lg={12}>
              <div className="diversity-block bg-blue text-white p-4 p-lg-5 rounded-3 text-center">
                <h2 className="modern-title section-title text-white">
                  Embrace Diversity, Explore Excellence
                </h2>
                <p className=" mb-0">
                  Experience the vibrant international community at ISBM
                  University, where students from around the world come together
                  to learn, grow, and thrive. Our commitment to diversity
                  fosters a welcoming environment where cultural exchange and
                  global perspectives are celebrated.
                </p>
              </div>
            </Col>
          </Row>

          {/* Join Family */}
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="cta-block text-center p-4 p-lg-5 rounded-3 shadow-lg border border-3 border-purple">
                <h2 className="text-blue modern-title section-title">
                  Join the ISBM University Family Today!
                </h2>
                <p className=" mb-4">
                  Come be a part of our dynamic community, where innovation
                  meets tradition, and every day brings new opportunities for
                  growth and discovery. Your journey to success begins at ISBM
                  University - where the world is your classroom, and the
                  possibilities are endless!
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-outline-purple btn-lg px-4 py-2"
                    onClick={() => setModalShow2(true)}
                  >
                    Enquire Now
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          <EnquiryNow
            show={modalShow2}
            onHide={() => setModalShow2(false)}
          />
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};

export default InternationalStudents;
